import React from 'react'
import {
  Button,
  Div,
  Flex,
  Input,
  Separator,
  Spacer,
  Text,
  Transition,
} from '@sendoutcards/quantum-design-ui'
import { useActions, useMutations, useState } from 'src/hooks'

const CreateAccount = (props: {
  onCreatedAccount: () => void
  orderNumber?: string
  isOrderFree?: true
}) => {
  const { orderNumber, onCreatedAccount, isOrderFree } = props
  const mutations = useMutations()
  const actions = useActions()
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [
    updateAccountFailureMessage,
    setUpdateAccountFailureMessage,
  ] = useState<string>()
  const [isUsernameInvalid, setIsUsernameInvalid] = useState(false)

  const onSubmit = async (username: string, password: string) => {
    try {
      setIsLoading(true)
      const {
        validateUsername: { valid: isValidUsername },
      } = await mutations.validateUsername({
        username,
        doNotShowDefaultTransition: true,
      })
      if (isValidUsername) {
        const account = (
          await mutations.updateAccount({
            account: { username, password },
            doNotShowDefaultTransition: true,
          })
        ).updateAccount.account
        actions.updatedAccount(account)
        onCreatedAccount()
      } else {
        setIsUsernameInvalid(true)
      }
    } catch (error) {
      setUpdateAccountFailureMessage(error.toString())
    } finally {
      setIsLoading(false)
    }
  }

  if (isLoading) {
    return <Transition title={'Creating your Account'} isLoading={isLoading} />
  }
  return (
    <form
      onSubmit={event => {
        event.preventDefault()
        onSubmit(username, password)
      }}
    >
      {orderNumber && isOrderFree && (
        <div>
          <Text type="title" weight="bold">
            Your card has been sent!
          </Text>
          <Spacer space="x2" />

          <Div>
            <Text type="caption">
              Order Number: <span>#{orderNumber}</span>
            </Text>
            <Separator orientation={'horizontal'} />
            <Spacer space="x2" />
          </Div>

          <Text type="caption">
            To continue, please finish setting up your account by entering your
            favorite username and password.
          </Text>
        </div>
      )}
      {(!orderNumber || isOrderFree) && (
        <div>
          <Text type="title" weight="bold">
            Finish Setting Up Your Account
          </Text>
          <Spacer space="x2" />
          <Text type="caption">
            To complete your purchase, please finish setting up your account by
            entering your favorite username and password.
          </Text>
        </div>
      )}
      <Spacer space="x4" />
      <Flex justifyContent="center">
        <Flex
          width="100%"
          height="116px"
          flexDirection="column"
          justifyContent="space-between"
        >
          <Input
            icon="user"
            placeholder="Username"
            onChange={setUsername}
            value={username}
            type={'text'}
            message={
              isUsernameInvalid
                ? { type: 'danger', content: 'Username is already taken.' }
                : undefined
            }
            isFullWidth={true}
          />
          <Input
            icon="lock"
            placeholder="Password"
            type="password"
            onChange={setPassword}
            value={password}
            message={
              updateAccountFailureMessage
                ? { type: 'danger', content: updateAccountFailureMessage }
                : undefined
            }
            isFullWidth={true}
          />
        </Flex>
      </Flex>
      <Spacer space="x4" />
      <Flex justifyContent="center">
        <Button
          title={'Finish my account'}
          onClick={() => onSubmit(username, password)}
          disabled={!username || !password}
        />
      </Flex>
      <Spacer space="x2" />
      {(!orderNumber || !isOrderFree) && (
        <div style={{ margin: '20px 0 0 0' }}>
          <Flex justifyContent="center">
            <Button
              title={'Go Back to Catalog'}
              onClick={() => actions.openCatalog()}
            />
          </Flex>
        </div>
      )}
    </form>
  )
}
export default CreateAccount
